import { FIELD_TYPES } from "constants/template-field-type";

export default {
  type: FIELD_TYPES.NESTED,
  label: "Bullets",
  fields: {
    bullets: {
      type: FIELD_TYPES.MULTIPLE_NESTED,
      label: "Bullets",
      maxLimit: 4,
      nestedConfig: {
        type: FIELD_TYPES.NESTED,
        fields: {
          bulletText: { type: FIELD_TYPES.TEXT, label: "Text", translatable: true }
        }
      }
    }
  }
};
